import styles from '../../styles/products.module.css';
import { KR } from '../../constants/localizations';


export default function ProductDeliveryRobotBoxDetailAmrE() {
    return (
        <div className={styles.robotDetails}>
            <div className={`${styles.robotDLeft} ${styles.amrE}`}>
                <div className={styles.flexBox}>
                    <span>{KR.label_products_detail_robot_size}</span>
                    <span className={styles.star}>2000(w)x3000(d)x1000(h)mm<span>*</span></span>
                </div>
                <div className={styles.flexBox}>
                    <span>{KR.label_products_detail_box_size}</span>
                    <span className={styles.star}>1500mmx2500mm<span>*</span></span>
                </div>
                <div className={styles.flexBox}>
                    <span>{KR.label_products_detail_max_quantity}</span>
                    <span className={styles.star}>5t<span>*</span></span>
                </div>
                <div className={styles.flexBox}>
                    <span>{KR.label_products_detail_speed}</span>
                    <span>0km/h ~3km/h</span>
                </div>
                <div className={styles.flexBox}>
                    <span>{KR.label_products_detail_angle}</span>
                    <span>경사각 5°(9%)</span>
                </div>
                <div className={styles.flexBox}>
                    <span>{KR.label_products_detail_sensor}</span>
                    <span>2D 라이다·3D 라이다·GMSL <br />카메라·리미트 스위치</span>
                </div>
            </div>
            <div className={styles.robotDRight}>
                <div className={styles.label}>
                    <span>제품 주요</span>
                    <span>기능 및 특징</span>
                </div>
                <div className={`${styles.labelContent} ${styles.amrELabelContent}`}>
                    <span>
                        FMS (군집 제어) 시스템 플랫폼 제공
                    </span>
                    <span>
                        HMI (사용자 인터페이스)
                    </span>
                    <span>
                        완전 무인 자율주행 솔루션
                    </span>
                    <span>
                        무선 조종기, 충전기 등 제공
                    </span>
                </div>
            </div>
            <span className={styles.amrEcustom}>* 개별 커스터마이징 가능</span>
        </div >
    )
}
